import React, { useState } from 'react'

type ImageWithFallbackProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'onError'> & {
  fallbackLabel?: string
  fallbackWrapperClassName?: string
  fallbackIconClassName?: string
  onError?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void
}

const FALLBACK_ICON_PATH = 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4'

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  src,
  alt,
  className,
  fallbackLabel = 'Imagem indisponível',
  fallbackWrapperClassName = 'flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100',
  fallbackIconClassName = 'w-12 h-12 text-gray-300',
  onError,
  ...imgProps
}) => {
  const [isError, setIsError] = useState(false)

  // Resetar erro quando o src mudar
  React.useEffect(() => {
    setIsError(false)
  }, [src])

  const handleError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setIsError(true)
    if (onError) {
      onError(event)
    }
  }

  if (!isError && src) {
    return <img src={src} alt={alt} className={className} onError={handleError} {...imgProps} />
  }

  return (
    <div
      role="img"
      aria-label={alt || fallbackLabel}
      className={fallbackWrapperClassName}
    >
      <svg
        className={fallbackIconClassName}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
          d={FALLBACK_ICON_PATH}
        />
      </svg>
    </div>
  )
}

export default ImageWithFallback

